import { environmentAtom } from '@data/fms/environment/states';
import { MediaClient } from '@tier4/webauto-media-client';
// import {
//   RemoteClient,
//   getRTCRequestSubscriber as originalGetRTCRequestSubscriber,
//   releaseRTCRequestSubscriber as originalReleaseRTCRequestSubscriber,
  // getMRMNotificationSubscriber as originalGetMRMNotificationSubscriber,
  // releaseMRMNotificationSubscriber as originalReleaseMRMNotificationSubscriber,
  // getStandbyManager as originalGetStandbyManager,
  // releaseStandbyManager as originalReleaseStandbyManager,
  // type RTCRequestSubscriber,
  // type MRMNotificationSubscriber,
  // type StandbyManager,
// } from '@tier4/webauto-remote-client';
import { useAtomValue } from 'jotai';
import { useCallback } from 'react';

export const useRemoteDevices = () => {
  const environment = useAtomValue(environmentAtom);

  const fetchDevices = useCallback(
    async (vehicleId: string) => {
      if (!environment) return;
      try {
        return await MediaClient.getRemoteDevices({
          projectId: environment.project_id,
          vehicleId,
          environmentId: environment.environment_id,
        });
      } catch (e) {
        console.error('Failed to fetch remote devices', e);
      }
    },
    [environment],
  );

  const getMediaQualityMonitor = useCallback(() => {
    if (!environment) return;
    try {
      return MediaClient.getMediaQualityMonitor({
        projectId: environment.project_id,
        environmentId: environment.environment_id,
      });
    } catch (e) {
      console.error('Failed to get media quality monitor', e);
    }
  }, [environment]);

  const releaseMediaQualityMonitor = useCallback(
    (monitor: MediaClient.MediaQualityMonitor) => {
      MediaClient.releaseMediaQualityMonitor(monitor);
    },
    [],
  );

  // const getRTCRequestSubscriber = useCallback(() => {
  //   if (!environment) return;
  //   try {
  //     return originalGetRTCRequestSubscriber({
  //       projectId: environment.project_id,
  //       environmentId: environment.environment_id,
  //     });
  //   } catch (e) {
  //     console.error('Failed to get RTC request subscriber', e);
  //   }
  // }, [environment]);

  // const releaseRTCRequestSubscriber = useCallback(
  //   (subscriber: RTCRequestSubscriber) => {
  //     originalReleaseRTCRequestSubscriber(subscriber);
  //   },
  //   [],
  // );

  // const getMRMNotificationSubscriber = useCallback(() => {
  //   if (!environment) return;
  //   try {
  //     return originalGetMRMNotificationSubscriber({
  //       projectId: environment.project_id,
  //       environmentId: environment.environment_id,
  //     });
  //   } catch (e) {
  //     console.error('Failed to get MRM notification subscriber', e);
  //   }
  // }, [environment]);

  // const releaseMRMNotificationSubscriber = useCallback(
  //   (subscriber: MRMNotificationSubscriber) => {
  //     originalReleaseMRMNotificationSubscriber(subscriber);
  //   },
  //   [],
  // );

  // const getStandbyManager = useCallback(() => {
  //   if (!environment) return;
  //   try {
  //     return originalGetStandbyManager({
  //       projectId: environment.project_id,
  //       environmentId: environment.environment_id,
  //       standbyType: 'backup',
  //     });
  //   } catch (e) {
  //     console.error('Failed to get standby manager', e);
  //   }
  // }, [environment]);

  // const releaseStandbyManager = useCallback((manager: StandbyManager) => {
  //   originalReleaseStandbyManager(manager);
  // }, []);

  return {
    fetchDevices,
    getMediaQualityMonitor,
    releaseMediaQualityMonitor,
    // getRTCRequestSubscriber,
    // releaseRTCRequestSubscriber,
    // getMRMNotificationSubscriber,
    // releaseMRMNotificationSubscriber,
    // getStandbyManager,
    // releaseStandbyManager,
  };
};
